module.exports = __webpack_public_path__ + "static/chunks/src/page-british-columbia/part-benefits/assets/image-financing.fac77fe89219d641f98ce46b9086d564.webp";